import styled from 'styled-components';

const Home = styled.section`
  padding: 1.5rem 2rem;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 1.5rem;
  }

  .ant-tag {
    cursor: pointer;
  }
`;

export default { Home };
